import { render } from "./BestDeals.vue?vue&type=template&id=ddb643b2&scoped=true"
import script from "./BestDeals.vue?vue&type=script&lang=js"
export * from "./BestDeals.vue?vue&type=script&lang=js"

import "./BestDeals.vue?vue&type=style&index=0&id=ddb643b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddb643b2"]])

export default __exports__